import { Component, ElementRef, Inject, Injector, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/header/header.component';
import { Select } from '@ngxs/store';
import { AppState, AppStateModel } from './app.state';
import { Observable } from 'rxjs';
import { setInjector, WINDOW } from './common/services/injection-tokens';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    injector: Injector,
    @Inject(WINDOW) private _window: Window | null,
  ) {
    setInjector(injector);
  }

  @Select(AppState)
  protected appState$!: Observable<AppStateModel>;

  @ViewChild('contentContainer')
  protected contentContainer?: ElementRef<HTMLElement>;

  public ngOnInit(): void {
    this._router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.contentContainer?.nativeElement?.scrollTo?.(<any>{ top: 0, left: 0, behavior: 'instant' });

        this._window?.scrollTo?.(<any>{ top: 0, left: 0, behavior: 'instant' });
      });
  }
}
